import { api } from "./api";

// Registers /sw.js (https only). Never throws — the site works identically without it.
export function registerServiceWorker() {
  if (!("serviceWorker" in navigator) || window.location.protocol !== "https:") return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

const b64ToUint8 = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
};

// Explicit opt-in flow: permission prompt -> push subscription -> stored server-side.
export async function subscribePush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window) || !("Notification" in window)) {
    return { ok: false, reason: "unsupported" };
  }
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return { ok: false, reason: perm };
  const { data } = await api.get("/push/vapid-key");
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: b64ToUint8(data.public_key),
  });
  await api.post("/push/subscribe", sub.toJSON());
  return { ok: true };
}

export async function unsubscribePush() {
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (sub) {
      await api.post("/push/unsubscribe", { endpoint: sub.endpoint }).catch(() => {});
      await sub.unsubscribe();
    }
  } catch (_) { /* best-effort */ }
}

// Home Screen icon badge (installed PWA only) — mirrors the unread bell count exactly.
export function syncAppBadge(unread) {
  try {
    if (!("setAppBadge" in navigator)) return;
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (!standalone) return;
    if (unread > 0) navigator.setAppBadge(unread);
    else navigator.clearAppBadge();
  } catch (_) { /* best-effort */ }
}
